export class Contacts {
  public id: number;
  public added_by: number;
  public salutation: string;
  public first_name: string;
  public middle_name: string;
  public last_name: string;
  public birthdate: string;
}
